module.exports = __webpack_public_path__ + "statisticsCover.6cf9a5d35db4e19a722c.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/statisticsCover.jpg
// module id = ../../../../../src/assets/coverPicks/statisticsCover.jpg
// module chunks = 0